import React, {useState} from 'react';
import ProductContainer from "./productContainer";
import {fetchProducts} from "../../../reduxLib/productLib";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import ProductExplorer from "./productExplorer";

const initialState = {
    "name": "",
    "SelectedCategory": "",
    "SelectedSubCategory": "",
    "productid": "",
    "productName": "",
}

function Products() {

    const [place,setPlace]=useState(initialState);

    let {categoryId,page} = useParams();
    if (page === undefined || page === null) {
        page = 1;
    }
    if(categoryId === undefined || categoryId === null) {
        categoryId=-1;
    }

    const [breadcrumb, setBreadcrumb] = useState([
        { label: "Home", to: "/products" },
        { label: "All Products" } // current
    ]);

    return (

            <main id="main-content" >
                <ProductContainer items={breadcrumb} />
                <ProductExplorer {...{categoryId,page}}  onBreadcrumbChange={setBreadcrumb}/>
            </main>

    );
}

export default Products;